export default __webpack_public_path__ + "static/media/drop-arrow-icon.ea8f6c7a.svg";